import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'deleteStr'
})
export class DeleteStrPipe implements PipeTransform {

  transform(value: string, tag: string): unknown {
    const openTag = '<' + tag + '>';
    const closeTag = '</' + tag + '>';
    return value.replace(openTag, '').replace(closeTag, '');
  }

}
